import {
  Avatar,
  Box,
  Button,
  CardMedia,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { Shirt } from "../../entities/Shirt";
import { useContext, useEffect, useState } from "react";
import DefaultShirt from "../../img/defaultShirt.png";
import PropertyChips from "../PropertyChips/PropertyChips";
import DeleteIcon from "@mui/icons-material/Delete";
import CurrentValue from "./CurrentValue";
import ShirtDetail from "../ShirtDetail/ShirtDetail";
import DialogService from "../Dialog/dialogService";
import LegitCheckService from "../../services/legitCheckService";
import { AbilityContext } from "../../permission/Can";
import LegitCheckResults from "../LegitCheckResults/LegitCheckResults";
import { Actions, Subjects } from "../../permission/constants";
import { LegitCheckItem } from "../../types/types";
interface Top10ElementShirtProps {
  shirt: Shirt;
  position: number;
  remove?: Function;
  userName: string;
}

const Top10ElementShirt = ({
  shirt,
  position,
  remove,
  userName,
}: Top10ElementShirtProps) => {
  const [image, setImage] = useState<string>(DefaultShirt);
  const [lcResults, setLcResults] = useState<Array<LegitCheckItem> | undefined>(
    undefined
  );
  const [positiveChecks, setPositiveChecks] = useState<number | undefined>(
    undefined
  );

  const { open, openMD } = DialogService();
  const ability = useContext(AbilityContext);
  const { getLegitChecks } = LegitCheckService();

  const removeItem = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (remove) {
      remove(position);
    }
  };
  const shirtDetails = () => {
    open(userName, <ShirtDetail shirt={shirt} />, []);
  };

  const legitCheckResults = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (shirt?.id) {
      openMD(
        "Legit Check Results",
        <LegitCheckResults itemId={shirt.id} legitChecks={lcResults} />,
        []
      );
    }
  };

  useEffect(() => {
    if (shirt.images[0]) {
      setImage(shirt.images[0].url);
    }

    if (shirt?.id && ability.can(Actions.VIEW, Subjects.LEGIT_CHECK)) {
      getLegitChecks(shirt.id).then((results) => {
        if (results) {
          const isLegitResults = results.filter((item) => item.is_legit).length;
          setLcResults(results);
          setPositiveChecks(isLegitResults);
        }
      });
    }
  }, [shirt]);

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1rem",
        height: "250px",
        backgroundColor: "#fff !important",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            marginRight: "1rem",
          }}
          onClick={shirtDetails}
        >
          <Avatar
            component={Paper}
            elevation={2}
            sx={{ elevation: 1, padding: "5px", bgcolor: "white" }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "#3c3c40",
                fontWeight: "700",
                fontSize: "1.75rem !important",
                fontFamily: "Manrope",
              }}
            >
              {position}
            </Typography>
          </Avatar>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            marginRight: "1rem",
          }}
          onClick={shirtDetails}
        >
          <Box
            sx={{
              position: "relative",
              width: 200,
              height: 200,
              bgcolor: "#f9f9f9",
            }}
          >
            <CardMedia
              component="img"
              image={image}
              alt={"Shirt image " + shirt.title}
              style={{
                height: 200,
                width: 200,
                borderRadius: "10px",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                color: "white",
                padding: "10px",
              }}
            >
              <PropertyChips shirt={shirt} />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          width: "calc(100% - 300px)",
          display: "flex",
          flexDirection: { sm: "column", lg: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          rowGap: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            cursor: "pointer",
          }}
          onClick={shirtDetails}
        >
          <Typography
            gutterBottom
            variant="body2"
            sx={{
              color: "#3c3c40",
              fontWeight: "700",
              fontSize: "1.25rem !important",
              marginBottom: "4px !important",
            }}
          >
            {shirt.model.team.name} - {shirt.model.season.start_year}/
            {shirt.model.season.end_year}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#6f7d95",
              fontWeight: "400",
              fontSize: "1rem !important",
            }}
          >
            {shirt.model.player
              ? shirt.model.player.alias &&
                shirt.model.player.name !== shirt.model.player.alias
                ? shirt.model.player.name +
                  ' "' +
                  shirt.model.player.alias +
                  '"'
                : shirt.model.player.name
              : ""}
          </Typography>
          {ability.can(Actions.VIEW, Subjects.LEGIT_CHECK) && (
            <Button
              variant="text"
              sx={{
                color: "#6f7d95",
                fontWeight: "600",
                fontSize: "0.8rem !important",
                textDecoration: "underline",
                padding: "0px 2px",
                justifyContent: "flex-start",
              }}
              onClick={legitCheckResults}
            >
              LC ({positiveChecks ? positiveChecks : "0"}/
              {lcResults ? lcResults.length : "0"})
            </Button>
          )}
        </Box>

        <Box
          sx={{
            width: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={shirtDetails}
        >
          <CurrentValue value={Number(shirt.current_price)} />
        </Box>
      </Box>

      {remove ? (
        <Box
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            width: "50px",
            height: "50px",
            color: "white",
          }}
        >
          <IconButton
            onClick={removeItem}
            sx={{
              color: "#bfbfbf",
              float: "right",
              fontSize: "30px !important",
            }}
          >
            <DeleteIcon
              sx={{ fontSize: "25px !important", color: "red !important" }}
            />
          </IconButton>
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default Top10ElementShirt;
